export interface AccessRow {
  content: string;
  format: string;
  extension: string;
}

export const accessRows: AccessRow[] = [
  { content: 'Los seis tomos actualizados', format: 'PDF descargable', extension: '323 páginas' },
  { content: 'Los cinco bonos actualizados', format: 'PDF descargable', extension: '215 páginas' }
];

export const accessChecks: string[] = [
  'PDF de alta calidad',
  'Imprimible en A4',
  'Optimizado para móvil y tablet',
  'Acceso inmediato sin esperas'
];
